import { jsonMember, jsonObject } from 'typedjson';

@jsonObject
export class WarehouseReceiptContextOperationsResponse {
  @jsonMember(Boolean)
  public readonly canBeEdited!: boolean;

  @jsonMember(Boolean)
  public readonly canBeViewed!: boolean;

  @jsonMember(Boolean)
  public readonly canBeApproved!: boolean;
}
